module.exports = __webpack_public_path__ + "media/images/vp/icon.heart-7b4de21c7e29d3711adfb86e20e8b8ec.svg";